import React from 'react'

import { type ParameterID, type CoreUserAddress } from '@flecto/types'
import { useModal } from '@flecto/ui'

import { ModalAddress } from './ModalAddress'

type UseModalAddressProps = {
  addressId?: ParameterID
  onSuccess?: (address: CoreUserAddress) => void
}
export function useModalAddress(props: UseModalAddressProps) {
  return useModal(<ModalAddress {...props} />)
}
